import React, { FC } from 'react';
import { HrefLang, RegionWithLangs } from '@navi-toolbox/seo';
import { HelmetContext } from '@okapi/helmet-react';

type Props = {
  currentPage: string;
  context: HelmetContext;
};

export const HrefLangMeta: FC<Props> = ({ currentPage, context }) => {
  const regions: RegionWithLangs[] = [
    {
      regionCodeIS03166: 'ru',
      languagesISO639: ['ru'],
    },
    {
      regionCodeIS03166: 'kz',
      languagesISO639: ['ru', 'kk'],
    },
  ];

  if (!currentPage) {
    return null;
  }
  return <HrefLang regions={regions} url={currentPage} context={context} />;
};
